











import { defineComponent, reactive } from '@vue/composition-api';
import { OlbIcon, OlbButton, ResponsiveUtils } from '@olbbank/vue-components';

export default defineComponent({
	components: {
		OlbIcon,
		OlbButton,
	},
	props: {
		mobileOnly: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const responsiveUtils = new ResponsiveUtils();
		const state = reactive({
			/**
			 * If true, the "more" content is shown.
			 */
			isMore: false,
			isSmVp: responsiveUtils.isSm(),
		});

		function enterTransition(el: HTMLElement) {
			el.style.height = 'auto';
		}

		function toggle() {
			state.isMore = !state.isMore;
		}

		function resizeHandler() {
			state.isSmVp = responsiveUtils.isSm();
		}
		props.mobileOnly && window.addEventListener('resize', resizeHandler);

		return {
			state,
			enterTransition,
			toggle,
		};
	},
});
